@if (permDir.uipermission() !== PERMISSIONS.NONE || permDir.editPermissions()) {
  <!--#region Label Top -->

  @if (settings().labelPosition === 'top') {
    <ng-container *ngTemplateOutlet="uiLabelTemplateRef"></ng-container>
  }
  <ng-content select="label[slot-top]"></ng-content>

  <!--#endregion Label Top -->

  <div uiinputcontent (click)="focusin()">
    <!--#region Default Icon Left-->

    @if (settings().defaultIconSlot === 'left') {
      <ng-container *ngTemplateOutlet="uiDefaultIconTemplateRef"></ng-container>
    }
    <ng-content select="icon[slot-left]"></ng-content>

    <!--#endregion Default Icon Left -->

    <!--#region Label Embedded -->

    @if (settings().labelPosition === 'embedded') {
      <ng-container *ngTemplateOutlet="uiLabelTemplateRef"></ng-container>
    }
    <ng-content select="label[slot-embedded]"></ng-content>

    <!--#endregion Label Embedded -->

    <!--#region Input -->
    @if (!this.settings().disabled) {
      <input
        #uiValueRef
        uivalue
        [class]="inputCssClass()"
        [value]="formattedValue()"
        [placeholder]="placeholder()"
        (keydown)="filterKeys($event, uiValueRef.value)"
        (keyup.enter)="uiValueRef.blur()"
        (focus)="focusin()"
        (blur)="focusout()"
      />
    } @else {
      <div uivalue uidisabled [class]="inputCssClass()">
        {{ formattedValue() }}
      </div>
    }

    <!--#endregion Input -->

    <!--#region Tools -->
    @if (!this.settings().disabled) {
      <div uitoolstrip>
        <ng-container #uiToolsDefaultRef>
          @if (
            settings().showClearButton &&
            !isNil(value()) &&
            !settings().disabled
          ) {
            <btn
              uihovertool
              uicleartool
              uiunpermissioned
              class="unstyled xxs"
              [settings]="{
                icon: ICONS.CLOSE_SMALL,
                iconOnly: true,
              }"
              (click)="reset()"
            >
            </btn>
          }
        </ng-container>
        <ng-template #uiToolsCodeRef></ng-template>
        <ng-content #uiToolsMarkupRef select="[uitool]"></ng-content>
      </div>
    }

    <!--#endregion Tools -->

    <!--#region Default Icon Right-->

    @if (settings().defaultIconSlot === 'right') {
      <ng-container *ngTemplateOutlet="uiDefaultIconTemplateRef"></ng-container>
    }
    <ng-content select="icon[slot-right]"></ng-content>

    <!--#endregion Default Icon Right -->
  </div>

  <!--#region Footer -->

  @switch (state()) {
    @case ('error') {
      <span
        uifooter
        uistate="error"
        class="cursor-help"
        [class]="footerCssClass()"
        [title]="errors().join('\r\n')"
        >{{
          errors().length > 1
            ? errors().at(0) +
              ' (' +
              (errors().length - 1).toString() +
              ' more)'
            : errors().at(0)
        }}</span
      >
    }
    @case ('warning') {
      <span
        uifooter
        uistate="warning"
        class="cursor-help"
        [class]="footerCssClass()"
        [title]="warnings().join('\r\n')"
        >{{
          warnings().length > 1
            ? warnings().at(0) +
              ' (' +
              (warnings().length - 1).toString() +
              ' more)'
            : warnings().at(0)
        }}</span
      >
    }
    @default {
      @if (footerContent()) {
        <span uifooter>{{ footerContent() }}</span>
      }
    }
  }

  <!--#endregion Footer  -->

  <!--#region Templates -->

  <!-- Label Template -->
  <ng-template #uiLabelTemplateRef>
    <label
      uipopuptrigger
      [class.hidden]="!settings().label && !settings().labelTip"
      [attr.slot-embedded]="
        settings().labelPosition === 'embedded' ? true : undefined
      "
      [label]="labelFormatted()"
      [labelTip]="labelTip()"
      [state]="state()"
    >
    </label>
  </ng-template>

  <!-- Default Icon Template-->
  <ng-template #uiDefaultIconTemplateRef> </ng-template>

  <!--#endregion Templates -->
}
